module.exports = __webpack_public_path__ + "static/img/icon-realtime.2206fc37.svg";